import { render, staticRenderFns } from "./GFileVideo.vue?vue&type=template&id=b171f796&"
import script from "./GFileVideo.vue?vue&type=script&lang=js&"
export * from "./GFileVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports